<script lang="ts">
  import { onMount } from 'svelte';

  import { portal } from '$lib/actions/portal';
  import { CLOSE } from '$lib/constants/text';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { closeCookieModal } from '$lib/store';
  import { EventNames, EventSectionName } from '$lib/types/analytics';
  import { PREFERENCE_COOKIE } from '$lib/types/cookies';
  import { CookieDismiss, getCookie, setCookiePreferences } from '$lib/utils/cookie';

  let isCookiePreferenceSet: string | undefined;
  let isMounted = false;

  const COOKIE_PREFERENCE = 'cookie-preference';

  const acceptCookiePolicy = (type: CookieDismiss) =>
    !getCookie(COOKIE_PREFERENCE) &&
    setCookiePreferences(
      PREFERENCE_COOKIE.ACCEPTED,
      EventSectionName.COOKIE_MODAL,
      EventNames.CONSENT_RECORDED,
      type
    );

  const COOKIE_POLICY_TEXT_1 =
    'We use third-party cookies to measure website performance and analytics, and personalize content and ads for you. Read our';
  const COOKIE_POLICY_TEXT_2 = 'for more details.';
  const COOKIE_POLICY = 'cookie policy';

  onMount(() => {
    isMounted = true;
    isCookiePreferenceSet = getCookie(COOKIE_PREFERENCE);
    if (!isCookiePreferenceSet) {
      sendAnalyticsEvent(EventNames.VIEW_PAGE, {
        section_name: EventSectionName.COOKIE_MODAL
      });
    }
    return () => {
      isMounted = false;
    };
  });
</script>

<svelte:window on:scroll={() => acceptCookiePolicy(CookieDismiss.SCROLL)} />

{#if !$closeCookieModal}
  <dialog open={isMounted && !isCookiePreferenceSet} class="cookie-overlay" use:portal={'#portal'}>
    <div class="cookie-modal">
      <p>
        {COOKIE_POLICY_TEXT_1}
        <a href="/cookie-policy" on:click={() => acceptCookiePolicy(CookieDismiss.POPUP_CTA)}>
          {COOKIE_POLICY}
        </a>
        {COOKIE_POLICY_TEXT_2}
      </p>
      <div class="consent-wrapper">
        <button class="consent-btn" on:click={() => acceptCookiePolicy(CookieDismiss.POPUP_CTA)}>
          {CLOSE}
        </button>
      </div>
    </div>
  </dialog>
{/if}

<style lang="scss">
  .cookie-overlay {
    position: fixed;
    bottom: 55px;
    left: 0;
    right: 0;
    border: none;
    background: transparent;
    padding: 12px;
    z-index: var(--z-index-cookie-policy);
  }

  .cookie-modal {
    background: var(--color-cookie-policy-bg);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 20px;
    p {
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-normal);
      color: var(--color-cookie-policy-text);
      line-height: 20px;
      margin: 0;

      a {
        color: var(--color-cookie-policy-link);
      }
    }
  }

  .consent-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .consent-btn {
    border: none;
    font-weight: var(--font-weight-medium);
    color: var(--color-title);
    font-size: var(--font-size-sm);
    background-color: #00b0bb;
    padding: 2px 10px;
    line-height: 20px;
    border-radius: 50px;
  }
</style>
